import _sfc_main from "./LoadingOverlay.vue2.mjs";
/* empty css                     */
import normalizeComponent from "../../_virtual/_plugin-vue2_normalizer.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { staticClass: "loading-overlay" }, [_c(_setup.SvgIcon, { staticClass: "loading", attrs: { "icon": _setup.LoadingScheduleIcon } }), _c("span", { staticClass: "loading-text" }, [_vm._v(_vm._s(_setup.t("Entering the room now...")))])], 1);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "88005025"
);
const LoadingOverlay = __component__.exports;
export {
  LoadingOverlay as default
};
